<div id="authorize-container" fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="example-container" fxFlex="30%" fxFlex.lt-md="65%" fxFlex.lt-sm="95%">
      <mat-card-content>
        <p *ngIf = "!loginMessage.successMessage && !loginMessage.errorMessage">{{'Loading' }}...</p>
        <p *ngIf = "loginMessage.successMessage">{{loginMessage.successMessage}}</p>
        <p *ngIf = "loginMessage.errorMessage" class = "api-error">{{loginMessage.errorMessage }}</p>
      </mat-card-content>
    </mat-card>
</div>    